<template>
  <admin-card title="Информация о пользователе" v-if="user">
    <div>
      <!-- User Name -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">Фото</label>
        <div class="col-md-7 col-form-label">
          <img :src="user.photo_url" width="100" />
        </div>
      </div>

      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">Имя</label>
        <div class="col-md-7 col-form-label">
          {{ user.name }}
        </div>
      </div>

      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">Email</label>
        <div class="col-md-7 col-form-label">
          {{ user.email }}
        </div>
      </div>

      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">Телефон</label>
        <div class="col-md-7 col-form-label">
          {{ user.phone }}
        </div>
      </div>

      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">Локация:</label>
        <div class="col-md-7 col-form-label">
          {{ location }}
        </div>
      </div>

      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">Род занятий:</label>
        <div class="col-md-7 col-form-label">
          {{ job }}
        </div>
      </div>
    </div>
  </admin-card>
</template>

<script>
  import { mapGetters } from 'vuex';
  import AdminPage from '../admin-page';

  export default {
    metaInfo () {
      return { title: 'Информация о пользователе' };
    },
    extends: AdminPage,
    data: () => ({}),
    computed: {
      ...mapGetters({
        user: 'users/user',
      }),
      location: function () {
        const locations = [];
        if (this.user.country) {
          locations.push(this.user.country);
        }
        if (this.user.city) {
          locations.push(this.user.city);
        }
        return locations.join(', ');
      },
      job: function () {
        const jobParts = [];
        if (this.user.specialization) {
          jobParts.push(this.user.specialization);
        }
        if (this.user.organization) {
          jobParts.push('"' + this.user.organization + '"');
        }
        return jobParts.join(' в компании ');
      },
    },
    methods: {
    },
    beforeMount () {
      const userId = parseInt(this.$route.params.id);

      this.$store.dispatch('users/find', userId);
    }
  }
</script>
